$(document).ready(function() {
    setTimeout(function() {
        (function($) {
            (function($) {
				var has_VML, create_canvas_for, add_shape_to, clear_canvas, shape_from_area,
					canvas_style, fader, hex_to_decimal, css3color, is_image_loaded, options_from_area;

				has_VML = document.namespaces;
				has_canvas = !!document.createElement('canvas').getContext;

				if(!(has_canvas || has_VML)) {
					$.fn.maphilight = function() { return this; };
					return;
				}

				if(has_canvas) {
					fader = function(element, opacity, interval) {
						if(opacity <= 1) {
							element.style.opacity = opacity;
							window.setTimeout(fader, 10, element, opacity + 0.1, 10);
						}
					};

					hex_to_decimal = function(hex) {
						return Math.max(0, Math.min(parseInt(hex, 16), 255));
					};
					css3color = function(color, opacity) {
						return 'rgba('+hex_to_decimal(color.substr(0,2))+','+hex_to_decimal(color.substr(2,2))+','+hex_to_decimal(color.substr(4,2))+','+opacity+')';
					};
					create_canvas_for = function(img) {
						var c = $('<canvas style="width:'+img.width+'px;height:'+img.height+'px;"></canvas>').get(0);
						c.getContext("2d").clearRect(0, 0, c.width, c.height);
						return c;
					};
					add_shape_to = function(canvas, shape, coords, options, name) {
						var i, context = canvas.getContext('2d');
						context.beginPath();
						if(shape == 'rect') {
							context.rect(coords[0], coords[1], coords[2] - coords[0], coords[3] - coords[1]);
						} else if(shape == 'poly') {
							context.moveTo(coords[0], coords[1]);
							for(i=2; i < coords.length; i+=2) {
								context.lineTo(coords[i], coords[i+1]);
							}
						} else if(shape == 'circ') {
							context.arc(coords[0], coords[1], coords[2], 0, Math.PI * 2, false);
						}
						context.closePath();
						if(options.fill) {
							context.fillStyle = css3color(options.fillColor, options.fillOpacity);
							context.fill();
						}
						if(options.stroke) {
							context.strokeStyle = css3color(options.strokeColor, options.strokeOpacity);
							context.lineWidth = options.strokeWidth;
							context.stroke();
						}
						if(options.fade) {
							fader(canvas, 0);
						}
					};
					clear_canvas = function(canvas, area) {
						canvas.getContext('2d').clearRect(0, 0, canvas.width,canvas.height);
					};
				} else {   // ie executes this code
					create_canvas_for = function(img) {
						return $('<var style="zoom:1;overflow:hidden;display:block;width:'+img.width+'px;height:'+img.height+'px;"></var>').get(0);
					};
					add_shape_to = function(canvas, shape, coords, options, name) {
						var fill, stroke, opacity, e;
						fill = '<v:fill color="#'+options.fillColor+'" opacity="'+(options.fill ? options.fillOpacity : 0)+'" />';
						stroke = (options.stroke ? 'strokeweight="'+options.strokeWidth+'" stroked="t" strokecolor="#'+options.strokeColor+'"' : 'stroked="f"');
						opacity = '<v:stroke opacity="'+options.strokeOpacity+'"/>';
						if(shape == 'rect') {
							e = $('<v:rect name="'+name+'" filled="t" '+stroke+' style="zoom:1;margin:0;padding:0;display:block;position:absolute;left:'+coords[0]+'px;top:'+coords[1]+'px;width:'+(coords[2] - coords[0])+'px;height:'+(coords[3] - coords[1])+'px;"></v:rect>');
						} else if(shape == 'poly') {
							e = $('<v:shape name="'+name+'" filled="t" '+stroke+' coordorigin="0,0" coordsize="'+canvas.width+','+canvas.height+'" path="m '+coords[0]+','+coords[1]+' l '+coords.join(',')+' x e" style="zoom:1;margin:0;padding:0;display:block;position:absolute;top:0px;left:0px;width:'+canvas.width+'px;height:'+canvas.height+'px;"></v:shape>');
						} else if(shape == 'circ') {
							e = $('<v:oval name="'+name+'" filled="t" '+stroke+' style="zoom:1;margin:0;padding:0;display:block;position:absolute;left:'+(coords[0] - coords[2])+'px;top:'+(coords[1] - coords[2])+'px;width:'+(coords[2]*2)+'px;height:'+(coords[2]*2)+'px;"></v:oval>');
						}
						e.get(0).innerHTML = fill+opacity;
						$(canvas).append(e);
					};
					clear_canvas = function(canvas) {
						$(canvas).find('[name=highlighted]').remove();
					};
				}

				shape_from_area = function(area) {
					var i, coords = area.getAttribute('coords').split(',');
					for (i=0; i < coords.length; i++) { coords[i] = parseFloat(coords[i]); }
				console.log("area:");
				console.log(area);
					return [area.getAttribute('shape').toLowerCase().substr(0,4), coords];
				};

				options_from_area = function(area, options) {
					var $area = $(area);
					return $.extend({}, options, $.metadata ? $area.metadata() : false, $area.data('maphilight'));
				};

				is_image_loaded = function(img) {
					if(!img.complete) { return false; } // IE
					if(typeof img.naturalWidth != "undefined" && img.naturalWidth == 0) { return false; } // Others
					return true;
				};

				canvas_style = {
					position: 'absolute',
					left: 0,
					top: 0,
					padding: 0,
					border: 0
				};

				var ie_hax_done = false;
				$.fn.maphilight = function(opts) {
					opts = $.extend({}, $.fn.maphilight.defaults, opts);



					return this.each(function() {
						var img, wrap, options, map, canvas, canvas_always, mouseover, highlighted_shape, usemap;
						img = $(this);

						if(!is_image_loaded(this)) {
							// If the image isn't fully loaded, this won't work right.  Try again later.
							return window.setTimeout(function() {
								img.maphilight(opts);
							}, 200);
						}

						options = $.extend({}, opts, $.metadata ? img.metadata() : false, img.data('maphilight'));

						// jQuery bug with Opera, results in full-url#usemap being returned from jQuery's attr.
						// So use raw getAttribute instead.
						usemap = img.get(0).getAttribute('usemap');

						map = $('map[name="'+usemap.substr(1)+'"]');

						if(!(img.is('img') && usemap && map.size() > 0)) { return; }

						if(img.hasClass('maphilighted')) {
							// We're redrawing an old map, probably to pick up changes to the options.
							// Just clear out all the old stuff.
							var wrapper = img.parent();
							img.insertBefore(wrapper);
							wrapper.remove();
						}

						wrap = $('<div></div>').css({
							display:'block',
							background:'url('+this.src+')',
							position:'relative',
							padding:0,
							width:this.width,
							height:this.height
							});
						if(options.wrapClass) {
							if(options.wrapClass === true) {
								wrap.addClass($(this).attr('class'));
							} else {
								wrap.addClass(options.wrapClass);
							}
						}
						img.before(wrap).css('opacity', 0).css(canvas_style).remove();

						wrap.append(img);

						canvas = create_canvas_for(this);
						$(canvas).css(canvas_style);
						canvas.height = this.height;
						canvas.width = this.width;

						mouseover = function(e) {
							// TODO: pogodan hacks - extend maphilight to allow this to be done dynamically
							clear_canvas(canvas);
							var new_html = $("#product_" + e.target.id).html();
							$('span.product_info').html(new_html || "");

							var shape, area_options;
							area_options = options_from_area(this, options);
							if(
								!area_options.neverOn
								// &&
								// !area_options.alwaysOn
							) {
								shape = shape_from_area(this);
								add_shape_to(canvas, shape[0], shape[1], area_options, "highlighted");
								if(area_options.groupBy && $(this).attr(area_options.groupBy)) {
									var first = this;
									map.find('area['+area_options.groupBy+'='+$(this).attr(area_options.groupBy)+']').each(function() {
										if(this != first) {
											var subarea_options = options_from_area(this, options);
											if(!subarea_options.neverOn && !subarea_options.alwaysOn) {
												var shape = shape_from_area(this);
												add_shape_to(canvas, shape[0], shape[1], subarea_options, "highlighted");
											}
										}
									});
								}
							}
						}

						if(options.alwaysOn) {
							$(map).find('area[coords]').each(mouseover);
						} else {
							// If the metadata plugin is present, there may be areas with alwaysOn set.
							// We'll add these to a *second* canvas, which will get around flickering during fading.
							$(map).find('area[coords]').each(function() {
								var shape, area_options;
								area_options = options_from_area(this, options);
								if(area_options.alwaysOn) {
									if(!canvas_always) {
										canvas_always = create_canvas_for(img.get());
										$(canvas_always).css(canvas_style);
										canvas_always.width = img.width();
										canvas_always.height = img.height();
										img.before(canvas_always);
									}

									shape = shape_from_area(this);
									add_shape_to(canvas_always, shape[0], shape[1], area_options, "");
								}
							});

							var hoverConfig = {
							  //timeout: 500, // number = milliseconds delay before onMouseOut
							  over: 			mouseover,
							  out:  			function(e) { },
								interval: 	200
							};

							$(map).find('area[coords]').hoverIntent(hoverConfig);
							//$(map).find('area[coords]').mouseover(mouseover).mouseout(function(e) { clear_canvas(canvas); });
						}

						img.before(canvas); // if we put this after, the mouseover events wouldn't fire.

						img.addClass('maphilighted');
					});
				};
				$.fn.maphilight.defaults = {
					fill: true,
					fillColor: '000000',
					fillOpacity: 0.2,
					stroke: true,
					strokeColor: 'ff0000',
					strokeOpacity: 1,
					strokeWidth: 1,
					fade: true,
					alwaysOn: false,
					neverOn: false,
					groupBy: false,
					wrapClass: true
				};
			})(jQuery);


			﻿/**
			* hoverIntent is similar to jQuery's built-in "hover" function except that
			* instead of firing the onMouseOver event immediately, hoverIntent checks
			* to see if the user's mouse has slowed down (beneath the sensitivity
			* threshold) before firing the onMouseOver event.
			*
			* hoverIntent r5 // 2007.03.27 // jQuery 1.1.2+
			* <http://cherne.net/brian/resources/jquery.hoverIntent.html>
			*
			* hoverIntent is currently available for use in all personal or commercial
			* projects under both MIT and GPL licenses. This means that you can choose
			* the license that best suits your project, and use it accordingly.
			*
			* // basic usage (just like .hover) receives onMouseOver and onMouseOut functions
			* $("ul li").hoverIntent( showNav , hideNav );
			*
			* // advanced usage receives configuration object only
			* $("ul li").hoverIntent({
			*	sensitivity: 7, // number = sensitivity threshold (must be 1 or higher)
			*	interval: 100,   // number = milliseconds of polling interval
			*	over: showNav,  // function = onMouseOver callback (required)
			*	timeout: 0,   // number = milliseconds delay before onMouseOut function call
			*	out: hideNav    // function = onMouseOut callback (required)
			* });
			*
			* @param  f  onMouseOver function || An object with configuration options
			* @param  g  onMouseOut function  || Nothing (use configuration options object)
			* @author    Brian Cherne <brian@cherne.net>
			*/
			(function($) {
				$.fn.hoverIntent = function(f,g) {
					// default configuration options
					var cfg = {
						sensitivity: 7,
						interval: 100,
						timeout: 0
					};
					// override configuration options with user supplied object
					cfg = $.extend(cfg, g ? { over: f, out: g } : f );

					// instantiate variables
					// cX, cY = current X and Y position of mouse, updated by mousemove event
					// pX, pY = previous X and Y position of mouse, set by mouseover and polling interval
					var cX, cY, pX, pY;

					// A private function for getting mouse position
					var track = function(ev) {
						cX = ev.pageX;
						cY = ev.pageY;
					};

					// A private function for comparing current and previous mouse position
					var compare = function(ev,ob) {
						ob.hoverIntent_t = clearTimeout(ob.hoverIntent_t);
						// compare mouse positions to see if they've crossed the threshold
						if ( ( Math.abs(pX-cX) + Math.abs(pY-cY) ) < cfg.sensitivity ) {
							$(ob).unbind("mousemove",track);
							// set hoverIntent state to true (so mouseOut can be called)
							ob.hoverIntent_s = 1;
							return cfg.over.apply(ob,[ev]);
						} else {
							// set previous coordinates for next time
							pX = cX; pY = cY;
							// use self-calling timeout, guarantees intervals are spaced out properly (avoids JavaScript timer bugs)
							ob.hoverIntent_t = setTimeout( function(){compare(ev, ob);} , cfg.interval );
						}
					};

					// A private function for delaying the mouseOut function
					var delay = function(ev,ob) {
						ob.hoverIntent_t = clearTimeout(ob.hoverIntent_t);
						ob.hoverIntent_s = 0;
						return cfg.out.apply(ob,[ev]);
					};

					// A private function for handling mouse 'hovering'
					var handleHover = function(e) {
						// next three lines copied from jQuery.hover, ignore children onMouseOver/onMouseOut
						var p = (e.type == "mouseover" ? e.fromElement : e.toElement) || e.relatedTarget;
						while ( p && p != this ) { try { p = p.parentNode; } catch(e) { p = this; } }
						if ( p == this ) { return false; }

						// copy objects to be passed into t (required for event object to be passed in IE)
						var ev = jQuery.extend({},e);
						var ob = this;

						// cancel hoverIntent timer if it exists
						if (ob.hoverIntent_t) { ob.hoverIntent_t = clearTimeout(ob.hoverIntent_t); }

						// else e.type == "onmouseover"
						if (e.type == "mouseover") {
							// set "previous" X and Y position based on initial entry point
							pX = ev.pageX; pY = ev.pageY;
							// update "current" X and Y position based on mousemove
							$(ob).bind("mousemove",track);
							// start polling interval (self-calling timeout) to compare mouse coordinates over time
							if (ob.hoverIntent_s != 1) { ob.hoverIntent_t = setTimeout( function(){compare(ev,ob);} , cfg.interval );}

						// else e.type == "onmouseout"
						} else {
							// unbind expensive mousemove event
							$(ob).unbind("mousemove",track);
							// if hoverIntent state is true, then call the mouseOut function after the specified delay
							if (ob.hoverIntent_s == 1) { ob.hoverIntent_t = setTimeout( function(){delay(ev,ob);} , cfg.timeout );}
						}
					};

					// bind the function to the two event listeners
					return this.mouseover(handleHover).mouseout(handleHover);
				};
			})(jQuery);

			/*
			 * Metadata - jQuery plugin for parsing metadata from elements
			 *
			 * Copyright (c) 2006 John Resig, Yehuda Katz, J�örn Zaefferer, Paul McLanahan
			 *
			 * Dual licensed under the MIT and GPL licenses:
			 *   http://www.opensource.org/licenses/mit-license.php
			 *   http://www.gnu.org/licenses/gpl.html
			 *
			 * Revision: $Id: jquery.metadata.js 3640 2007-10-11 18:34:38Z pmclanahan $
			 *
			 */

			/**
			 * Sets the type of metadata to use. Metadata is encoded in JSON, and each property
			 * in the JSON will become a property of the element itself.
			 *
			 * There are four supported types of metadata storage:
			 *
			 *   attr:  Inside an attribute. The name parameter indicates *which* attribute.
			 *
			 *   class: Inside the class attribute, wrapped in curly braces: { }
			 *
			 *   elem:  Inside a child element (e.g. a script tag). The
			 *          name parameter indicates *which* element.
			 *   html5: Values are stored in data-* attributes.
			 *
			 * The metadata for an element is loaded the first time the element is accessed via jQuery.
			 *
			 * As a result, you can define the metadata type, use $(expr) to load the metadata into the elements
			 * matched by expr, then redefine the metadata type and run another $(expr) for other elements.
			 *
			 * @name $.metadata.setType
			 *
			 * @example <p id="one" class="some_class {item_id: 1, item_label: 'Label'}">This is a p</p>
			 * @before $.metadata.setType("class")
			 * @after $("#one").metadata().item_id == 1; $("#one").metadata().item_label == "Label"
			 * @desc Reads metadata from the class attribute
			 *
			 * @example <p id="one" class="some_class" data="{item_id: 1, item_label: 'Label'}">This is a p</p>
			 * @before $.metadata.setType("attr", "data")
			 * @after $("#one").metadata().item_id == 1; $("#one").metadata().item_label == "Label"
			 * @desc Reads metadata from a "data" attribute
			 *
			 * @example <p id="one" class="some_class"><script>{item_id: 1, item_label: 'Label'}</script>This is a p</p>
			 * @before $.metadata.setType("elem", "script")
			 * @after $("#one").metadata().item_id == 1; $("#one").metadata().item_label == "Label"
			 * @desc Reads metadata from a nested script element
			 *
			 * @example <p id="one" class="some_class" data-item_id="1" data-item_label="Label">This is a p</p>
			 * @before $.metadata.setType("html5")
			 * @after $("#one").metadata().item_id == 1; $("#one").metadata().item_label == "Label"
			 * @desc Reads metadata from a series of data-* attributes
			 *
			 * @param String type The encoding type
			 * @param String name The name of the attribute to be used to get metadata (optional)
			 * @cat Plugins/Metadata
			 * @descr Sets the type of encoding to be used when loading metadata for the first time
			 * @type undefined
			 * @see metadata()
			 */

			(function($) {

			$.extend({
			  metadata : {
				defaults : {
				  type: 'class',
				  name: 'metadata',
				  cre: /({.*})/,
				  single: 'metadata'
				},
				setType: function( type, name ){
				  this.defaults.type = type;
				  this.defaults.name = name;
				},
				get: function( elem, opts ){
				  var settings = $.extend({},this.defaults,opts);
				  // check for empty string in single property
				  if ( !settings.single.length ) settings.single = 'metadata';

				  var data = $.data(elem, settings.single);
				  // returned cached data if it already exists
				  if ( data ) return data;

				  data = "{}";

				  var getData = function(data) {
					if(typeof data != "string") return data;

					if( data.indexOf('{') < 0 ) {
					  data = eval("(" + data + ")");
					}
				  }

				  var getObject = function(data) {
					if(typeof data != "string") return data;

					data = eval("(" + data + ")");
					return data;
				  }

				  if ( settings.type == "html5" ) {
					var object = {};
					$( elem.attributes ).each(function() {
					  var name = this.nodeName;
					  if(name.match(/^data-/)) name = name.replace(/^data-/, '');
					  else return true;
					  object[name] = getObject(this.nodeValue);
					});
				  } else {
					if ( settings.type == "class" ) {
					  var m = settings.cre.exec( elem.className );
					  if ( m )
						data = m[1];
					} else if ( settings.type == "elem" ) {
					  if( !elem.getElementsByTagName ) return;
					  var e = elem.getElementsByTagName(settings.name);
					  if ( e.length )
						data = $.trim(e[0].innerHTML);
					} else if ( elem.getAttribute != undefined ) {
					  var attr = elem.getAttribute( settings.name );
					  if ( attr )
						data = attr;
					}
					object = getObject(data.indexOf("{") < 0 ? "{" + data + "}" : data);
				  }

				  $.data( elem, settings.single, object );
				  return object;
				}
			  }
			});

			/**
			 * Returns the metadata object for the first member of the jQuery object.
			 *
			 * @name metadata
			 * @descr Returns element's metadata object
			 * @param Object opts An object contianing settings to override the defaults
			 * @type jQuery
			 * @cat Plugins/Metadata
			 */
			$.fn.metadata = function( opts ){
			  return $.metadata.get( this[0], opts );
			};

			})(jQuery);
            console.log("DELAYED FUNCTION EXECUTED!");
        })(jQuery);
    }, 1000);
});